import React from "react";
import { LoadingSpinner } from "components";

export default function FullPageLoader() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <LoadingSpinner size={48} />
    </div>
  );
}
